import { Component } from '@theme/component';

class LbeWidget extends Component {
  /** @type {MutationObserver | null} */
  #observer = null;

  /** @type {string} */
  #previousRef = '';

  connectedCallback() {
    super.connectedCallback();

    this.#previousRef = this.dataset.clientRef ?? '';
    this.#observeLoading();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#observer?.disconnect();
  }

  updatedCallback() {
    super.updatedCallback();

    const newRef = this.dataset.clientRef ?? '';
    if (newRef === this.#previousRef) return;

    this.#previousRef = newRef;

    this.removeAttribute('data-loaded');
    this.#reloadWidget();
  }

  #reloadWidget() {
    const target = this.refs.target;
    if (!target || Array.isArray(target)) return;

    // Clear previous widget render
    for (const child of [...target.children]) {
      child.remove();
    }

    // Use LBE's official reload API
    if (typeof window.reloadWidgets === 'function') {
      window.reloadWidgets();
    } else {
      // Fallback: re-inject script to force re-scan
      const oldScript = /** @type {HTMLScriptElement | null} */ (
        document.querySelector('script[src*="labelleempreinte"]')
      );

      if (oldScript) {
        const script = document.createElement('script');
        script.src = oldScript.src;

        oldScript.after(script);
        oldScript.remove();
      }
    }

    this.#observeLoading();
  }

  #observeLoading() {
    this.#observer?.disconnect();

    const target = this.refs.target;
    if (!target || Array.isArray(target)) return;

    // Widget déjà présent
    if (target.children.length > 0) {
      this.setAttribute('data-loaded', '');
      return;
    }

    // Attend uniquement que LBE injecte son contenu
    this.#observer = new MutationObserver(() => {
      if (target.children.length > 0) {
        this.setAttribute('data-loaded', '');

        // Plus besoin d'observer une fois chargé
        this.#observer?.disconnect();
      }
    });

    this.#observer.observe(target, {
      childList: true,
      subtree: true,
    });
  }
}

customElements.define('lbe-widget', LbeWidget);